// kitchenMenuApi.js
import apiClient from '../../../../../services/apiClient';

const withQuery = (base, params = {}) => {
  const query = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return query ? `${base}?${query}` : base;
};

export const kitchenMenuApi = {
  getDay: async (kindergartenId, date) => {
    const result = await apiClient.get(withQuery('kitchen/menu/day', { kindergartenId, date }));
    return result.data || null;
  },

  saveDay: async (data) => {
    const result = await apiClient.put('kitchen/menu/day', data);
    return result.data;
  },

  suggestPortions: async (kindergartenId, date) => {
    const result = await apiClient.get(withQuery('kitchen/menu/suggest-portions', { kindergartenId, date }));
    return result.data || {};
  },

  checkSufficiency: async (kindergartenId, date) => {
    const result = await apiClient.get(withQuery('kitchen/menu/sufficiency', { kindergartenId, date }));
    return result.data || [];
  },

  cook: async (kindergartenId, date) => {
    const result = await apiClient.put('kitchen/menu/cook', { kindergartenId, date });
    return result.data;
  }
};

export default kitchenMenuApi;
